import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
/* oxlint-disable no-duplicate-case -- intentional duplicate case labels for route aliases; oxlint anchors the diagnostic at the first occurrence so per-line disables don't apply. */
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import {
	MENU_ID_ASSETS,
	MENU_ID_ASSETS_REPORTS,
	MENU_ID_ASSETS_SCHEMAS,
	MENU_ID_ASSETS_FOR_YOU,
} from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>([
	'assets',
	'assets-configure',
	'assets-data-manager-getting-started',
	'assets-data-manager-object-classes',
	'assets-data-manager-object-classes-settings',
	'assets-data-manager-object-class-settings',
	'assets-data-manager-data-dictionary-group',
	'assets-data-manager-data-source',
	'assets-data-manager-object-class-view',
	'assets-data-manager-object-detail-view',
	'assets-data-manager-data-dictionary-issues',
	'assets-data-manager-discover',
	'assets-object',
	'assets-schema',
	'assets-for-you',
	'assets-schema-configuration',
	'assets-object-type-configuration',
	'assets-reports',
	'assets-reports-default-redirect',
	'assets-reports-unsubscribe',
	'assets-analytics-data-view-create',
	'assets-analytics-data-view-details',
	'assets-analytics-data-view-list',
	'assets-dashboards',
	'assets-dashboards-detail',
	'servicedesk-cmdb-assets',
	'servicedesk-cmdb-configure',
	'servicedesk-cmdb-object',
	'servicedesk-cmdb-object-schema',
	'servicedesk-cmdb-object-schema-configuration',
	'servicedesk-cmdb-object-type-configuration',
	'servicedesk-cmdb-assets-reports',
	'servicedesk-cmdb-assets-reports-default-redirect',
	'servicedesk-cmdb-assets-reports-unsubscribe',
	'servicedesk-cmdb-insight',
	'servicedesk-cmdb-configure',
	'servicedesk-cmdb-object',
	'servicedesk-cmdb-object-schema',
	'servicedesk-cmdb-object-schema-configuration',
	'servicedesk-cmdb-object-type-configuration',
	'servicedesk-cmdb-assets-analytics-data-view-create',
	'servicedesk-cmdb-assets-analytics-data-view-details',
	'servicedesk-cmdb-assets-analytics-data-view-list',
	'servicedesk-cmdb-assets-dashboards',
	'servicedesk-cmdb-assets-dashboards-detail',
]);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName: RouteName = routeContext.route.name;
	const path: string[] = [MENU_ID_ASSETS];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [MENU_ID_ASSETS];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;
	switch (routeName) {
		case 'assets-for-you':
			path.push(MENU_ID_ASSETS_FOR_YOU);
			break;

		case 'servicedesk-cmdb-assets':
		case 'servicedesk-cmdb-object':
		case 'servicedesk-cmdb-object-schema':
		case 'servicedesk-cmdb-object-schema-configuration':
		case 'servicedesk-cmdb-object-type-configuration':
			path.push(MENU_ID_ASSETS_SCHEMAS);
			break;

		// Duplicate route-names of the above routes
		case 'servicedesk-cmdb-object':
		// oxlint-disable-next-line no-fallthrough
		case 'servicedesk-cmdb-object-schema':
		// oxlint-disable-next-line no-fallthrough
		case 'servicedesk-cmdb-object-schema-configuration':
		// oxlint-disable-next-line no-fallthrough
		case 'servicedesk-cmdb-object-type-configuration':
			path.push(MENU_ID_ASSETS_SCHEMAS);
			break;

		case 'servicedesk-cmdb-assets-reports':
		case 'servicedesk-cmdb-assets-reports-default-redirect':
		case 'servicedesk-cmdb-assets-reports-unsubscribe':
		case 'servicedesk-cmdb-assets-analytics-data-view-create':
		case 'servicedesk-cmdb-assets-analytics-data-view-details':
		case 'servicedesk-cmdb-assets-analytics-data-view-list':
		case 'servicedesk-cmdb-assets-dashboards':
		case 'servicedesk-cmdb-assets-dashboards-detail':
			path.push(MENU_ID_ASSETS_REPORTS);
			break;

		default:
			break;
	}

	return path;
}

export const assetsConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
